import axios from '@/utils/axios'

// 获取当前验证模式
export function ProductVerifyStageGet (params) {
  return axios({
    url: '/Sale/Task/ProductVerifyStageGet',
    method: 'get',
    params: params
  })
}

// 回答问题1问题接口
export function ProductVerifyQuestion1 (params) {
  return axios({
    url: '/Sale/Task/ProductVerifyQuestion1',
    method: 'get',
    params: params
  })
}

// 回答问题1回答接口
export function ProductVerifyAnswer1 (data) {
  return axios({
    url: '/Sale/Task/ProductVerifyAnswer1',
    method: 'post',
    data: data
  })
}

// 回答问题2问题接口
export function ProductVerifyQuestion2 (params) {
  return axios({
    url: '/Sale/Task/ProductVerifyQuestion2',
    method: 'get',
    params: params
  })
}

// 回答问题2回答接口
export function ProductVerifyAnswer2 (data) {
  return axios({
    url: '/Sale/Task/ProductVerifyAnswer2',
    method: 'post',
    data: data
  })
}

// 回答问题3问题接口
export function ProductVerifyQuestion3 (params) {
  return axios({
    url: '/Sale/Task/ProductVerifyQuestion3',
    method: 'get',
    params: params
  })
}

// 回答问题3回答接口
export function ProductVerifyAnswer3 (data) {
  return axios({
    url: '/Sale/Task/ProductVerifyAnswer3',
    method: 'post',
    data: data
  })
}
